module.exports = __webpack_public_path__ + "media/npc_dota_hero_viper.550fa8cf.webm";